// Generated by scripts/med-images/build.py — do not edit.

export interface MedImageMeta {
  w: number;
  h: number;
  /** Author and licence, shown under the image. */
  credit: string;
  page: string;
}

export const MED_IMAGES = {
  kub_supine: {
    w: 120,
    h: 104,
    credit: "Hellerhoff，CC BY-SA 3.0",
    page: "https://commons.wikimedia.org/wiki/File:Duenndarmileus_Chiasamen_-_Roe_-_0001.jpg",
  },
  kub_upright: {
    w: 144,
    h: 104,
    credit: "Igboeze，CC BY-SA 4.0",
    page: "https://commons.wikimedia.org/wiki/File:1._Bowel-obstruction-x-ray.jpg",
  },
  ct_hernia_ax: {
    w: 117,
    h: 104,
    credit: "Hellerhoff，CC BY-SA 4.0",
    page: "https://commons.wikimedia.org/wiki/File:Inkarzerierte_Schenkelhernie_rechts_mit_Ileus_81W_-_CT_-_001.jpg",
  },
  ct_hernia_cor: {
    w: 99,
    h: 104,
    credit: "Hellerhoff，CC BY-SA 4.0",
    page: "https://commons.wikimedia.org/wiki/File:Inkarzerierte_Schenkelhernie_rechts_mit_Ileus_81W_-_CT_-_001.jpg",
  },
  us_cbd: {
    w: 71,
    h: 104,
    credit: "Mikael Häggström，CC0",
    page: "https://commons.wikimedia.org/wiki/File:Ultrasonography_of_common_bile_duct_stone,_with_arrow.jpg",
  },
  mrcp: {
    w: 103,
    h: 104,
    credit: "Hellerhoff，CC BY-SA 3.0",
    page: "https://commons.wikimedia.org/wiki/File:MRCP_Choledocholithiasis.jpg",
  },
  ioc: {
    w: 124,
    h: 104,
    credit: "Bakerstmd，CC BY-SA 4.0",
    page: "https://commons.wikimedia.org/wiki/File:Cholangiogram_with_labels.jpg",
  },
  ct_stump: {
    w: 170,
    h: 96,
    credit: "J Gastric Cancer 2016;16(1):28 (PMC4834618)，CC BY-NC 3.0",
    page: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4834618/",
  },
  ct_gda: {
    w: 87,
    h: 104,
    credit: "Case Rep Med 2010:280430 (PMC2892662)，CC BY 3.0",
    page: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2892662/",
  },
  angio_gda: {
    w: 135,
    h: 104,
    credit: "Case Rep Med 2010:280430 (PMC2892662)，CC BY 3.0",
    page: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2892662/",
  },
  angio_coil: {
    w: 136,
    h: 104,
    credit: "Case Rep Med 2010:280430 (PMC2892662)，CC BY 3.0",
    page: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2892662/",
  },
  tex_liver: {
    w: 64,
    h: 55,
    credit: "Hic et nunc，CC BY-SA 3.0",
    page: "https://commons.wikimedia.org/wiki/File:Gallbladder_in_laparoscopy.jpg",
  },
  tex_omentum: {
    w: 64,
    h: 43,
    credit: "Hic et nunc，CC BY-SA 3.0",
    page: "https://commons.wikimedia.org/wiki/File:Gallbladder_in_laparoscopy.jpg",
  },
  tex_fat: {
    w: 56,
    h: 63,
    credit: "Case Rep Med 2014:787631 (PMC4158187)，CC BY 3.0",
    page: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4158187/",
  },
  tex_gb: {
    w: 47,
    h: 56,
    credit: "Minim Invasive Surg 2014:909321 (PMC4021750)，CC BY 3.0",
    page: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4021750/",
  },
} as const satisfies Record<string, MedImageMeta>;

export type MedImageId = keyof typeof MED_IMAGES;
